import { PudoLocation } from '@pperform/pp-data-mappers';
import { useState } from 'preact/hooks';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import AppError from 'exceptions/AppError';
import { ptpCatchError } from 'services/sentry.services';
import { ErrorCodes } from 'constants/errors.constants';
import { isRuntimeError } from 'utils/fetcher.utils';
import { bookReturn } from '../services';

const useBooking = ({
  collectionPoint,
  shipmentPk,
  shipmentUuid,
  returnUuid,
  returnStatus,
  bookingCount,
}: {
  collectionPoint: PudoLocation;
  shipmentPk: number;
  shipmentUuid: string;
  returnUuid: string;
  returnStatus: string;
  bookingCount: number;
}): {
  onBooking: () => Promise<void>;
  process: {
    success?: boolean;
    error?: any;
    loading?: boolean;
  };
} => {
  const [process, setProcess] = useState<{
    loading?: boolean;
    error?: any;
    success?: boolean;
  }>({});
  const globalConfig = useGlobalConfigContext();

  const onBooking = async () => {
    try {
      setProcess({ loading: true });
      await bookReturn({
        orgName: globalConfig.organizationName,
        orgId: globalConfig.organizationId,
        collectionPoint,
        shipmentPk,
        shipmentUuid,
        returnUuid,
        returnStatus,
        bookingCount,
      });
      setProcess({ success: true });
    } catch (error) {
      if (isRuntimeError(error)) {
        ptpCatchError(error);
        setProcess({ error: new Error(ErrorCodes.GeneralError) });
      }
      setProcess({ error });
    }
  };

  return {
    onBooking,
    process,
  };
};

export { useBooking };
